export const weakStringContainsFilter = (row, columnId, filterValue) => {
  if (!filterValue) return true; // Don't filter if filter is undefined
  let rowValue = row.getValue(columnId);
  if (!rowValue) return false; // No filter match if value is undefined
  const normalizedValue = rowValue.toString().toLowerCase().trim();
  const normalizedFilter = filterValue.toString().toLowerCase().trim();
  return normalizedValue.includes(normalizedFilter);
};

export const customScaledKiloUnitInRange = (row, columnId, filterValue) => {
  if (!filterValue) return true;
  let rowValue = row.getValue(columnId);

  const [min, max] = filterValue;
  const scaledMin = min != null ? min * 1000 : undefined;
  const scaledMax = max != null ? max * 1000 : undefined;

  return (scaledMin == null || rowValue >= scaledMin) && (scaledMax == null || rowValue <= scaledMax);
};

export const customNumberPercentageInRange = (row, columnId, filterValue) => {
  if (!filterValue) return true;
  let rowValue = row.getValue(columnId);

  const [min, max] = filterValue;
  const scaledMin = min != null ? min * 0.01 : undefined;
  const scaledMax = max != null ? max * 0.01 : undefined;

  return (scaledMin == null || rowValue >= scaledMin) && (scaledMax == null || rowValue <= scaledMax);
};

export const customDatetimeRangeFilter = (row, columnId, filterValue) => {
  const dateValue = row.getValue(columnId);
  const [start, end] = filterValue || [];

  if (!dateValue) {
    // if Range is open with end date, we show nulls
    return end == null;
  }

  const parsedDate = new Date(dateValue);
  const parsedStart = start ? new Date(start) : null;
  const parsedEnd = end ? new Date(end) : null;

  if (parsedStart && parsedEnd) {
    return parsedDate >= parsedStart && parsedDate <= parsedEnd;
  }
  if (parsedStart) {
    return parsedDate >= parsedStart;
  }
  if (parsedEnd) {
    return parsedDate <= parsedEnd;
  }
  //default
  return true;
};

export const triStateBooleanFilter = (row, columnId, filterValue) => {
  if (filterValue !== true && filterValue !== false) return true; // "both" / no filter
  return Boolean(row.getValue(columnId)) === filterValue;
};

//TODO update this dict when you add new custom filter fns
export const filterFnsDict = {
  customScaledKiloUnitInRange: customScaledKiloUnitInRange,
  weakStringContainsFilter: weakStringContainsFilter,
  customNumberPercentageInRange: customNumberPercentageInRange,
  customDatetimeRangeFilter: customDatetimeRangeFilter,
  triStateBooleanFilter: triStateBooleanFilter,
};
